import styled from "styled-components"

const Title = styled.h2`

  &::after {
    background-color: ${(props) => props.theme.a_color_gradients.a_dark};
  }
}
`
const ZoneLibre = styled.div`
  background-color: ${(props) => props.bgColor};
  position: relative;
`

export { Title, ZoneLibre }
